/** @example 10 */
export const CURRENCY_FORMAT_NO_DECIMALS = '1.0-0';

/** @example 10.25 */
export const CURRENCY_FORMAT_DECIMALS = '1.2-2';
